import { useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import dayjs from "dayjs";
import { Button, Calendar, Label, Popover, PopoverContent, PopoverTrigger } from "@patient-watch/ui";
import { cn } from "@patient-watch/ui/utils";

interface ExportDatePickerProps {
    id: string;
    label: string;
    value: string;
    onChange: (value: string) => void;
}

export function ExportDatePicker({ id, label, value, onChange }: ExportDatePickerProps) {
    const [open, setOpen] = useState(false);
    const selectedDate = value && dayjs(value).isValid() ? dayjs(value).toDate() : undefined;

    return (
        <div className="space-y-2">
            <Label htmlFor={id}>{label}</Label>
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        id={id}
                        type="button"
                        variant="outline"
                        className={cn("justify-start w-full font-normal text-left", !value && "text-muted-foreground")}
                    >
                        <CalendarIcon className="mr-2 w-4 h-4" />
                        {value && dayjs(value).isValid() ? dayjs(value).format("D MMMM YYYY") : "Pick a date"}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="p-0 w-auto" align="start">
                    <Calendar
                        mode="single"
                        selected={selectedDate}
                        onSelect={(date) => {
                            if (!date) return;
                            onChange(dayjs(date).format("YYYY-MM-DD"));
                            setOpen(false);
                        }}
                        defaultMonth={selectedDate}
                        initialFocus
                    />
                </PopoverContent>
            </Popover>
        </div>
    );
}
